(function() {
  'use strict';

  function AnnouncementsReorderController(
    RouterHelper,
    Announcements,
    AnnouncementsUtils,
    Notify,
    $translate,
    Utils // Replaced Router with RouterHelper
  ) {
    var ctrl = this;
    ctrl.reorderInfo = $translate.instant(
      'Drag and drop announcements in the list below in order to re-order them. ' +
      'The order you set here will determine the order these announcements are shown ' +
      'on the user\'s dashboard. You can use the <strong>Preview</strong> on the right ' +
      'to see how the list of announcements will look like on a specific user. ' +
      'The order is saved automatically. ' +
      'When you are done, click the <strong>Done</strong> button.');

    Utils.setPageTitle('Reorder announcements');

    // Function declarations
    function loadAnnouncements() {
      Announcements.findAll({ cached: false })
        .then(function(items) {
          ctrl.announcements = _.chain(items)
                                .filter(function(item) {
                                  return AnnouncementsUtils.canBeReordered(item);
                                })
                                .sortBy(function(item) {
                                  return item.order;
                                })
                                .value();

          ctrl.loaded = true;
        });
    }

    // Initialize controller when component is ready
    ctrl.$onInit = function() {
      loadAnnouncements();
    };

    /**
     * Get the border class for the announcement.
     * This just calls another method on a service.
     * @param  {Object} item The announcement object.
     * @return {String}      The border class.
     */
    ctrl.getBorderClass = function(item) {
      return AnnouncementsUtils.getBorderClass(item);
    };

    /**
     * Get the border class for the announcement.
     * This just calls another method on a service.
     * @param  {Object} item The announcement object.
     * @return {String}      The border class.
     */
    ctrl.getBorderClass = AnnouncementsUtils.getBorderClass;

    /**
     * Reorder the announcements.
     * @param  {Object} evt The reorder event, as provided by Sortable.js.
     * @return {void}
     */
    ctrl.reorder = function(evt) {
      evt.models.forEach(function(model, index) {
        var order = index + 1;
        if (model.order === order) {
          return;
        }
        model.order = order;
        Announcements.saveOrder(model._id, order)
          .then(function(data) { model._rev = data._rev; })
          .catch(Utils.showError);
      });
      Notify.success('Order successfully updated!', 'Success');
    };

    ctrl.actions = [
      {
        label: $translate.instant('Done'),
        icon: 'icon-check',
        onClick: function() {
          RouterHelper.navigate(['/announcements']);
        },
        klass: 'btn-success'
      }
    ];
  }

  AnnouncementsReorderController.$inject = [
    'RouterHelperService',
    'AnnouncementsService',
    'AnnouncementsUtils',
    'NotifyService',
    '$translate',
    'UtilsService'
  ];

  angular.module('component.announcements')
    .controller('AnnouncementsReorderController', AnnouncementsReorderController);
})();
